import React from 'react';

interface ShimmerRowProps {
  columns: number;
  height?: string;
  className?: string;
}

const ShimmerRow: React.FC<ShimmerRowProps> = ({ 
  columns, 
  height = '60px',
  className = ''
}) => {
  return (
    <tr className={className}>
      {Array.from({ length: columns }).map((_, index) => (
        <td key={index} style={{ padding: '16px', verticalAlign: 'middle' }}>
          <div
            className="shimmer-loader"
            style={{
              height,
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 1.5s infinite'
            }}
          />
        </td>
      ))}
    </tr>
  );
};

export default ShimmerRow; 